import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import listUtils from "../../../_services/list-utils";
import { AuthDataStatus } from "../../../_statics/AuthDataStatus";
import stringUtils from "../../../_services/string-utils";
import { updateConnectedAuthDataForClient } from "../services/clients.actions";

const PaypalResponseHandler = () => {
    const dispatch = useDispatch();
    const clientReducer = useSelector((state) => state.client);

    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (
            clientReducer.clients &&
            !stringUtils.isBlank(searchParams.get("client")) &&
            !stringUtils.isBlank(searchParams.get("merchantIdInPayPal")) &&
            searchParams.get("permissionsGranted")
        ) {
            const selectedClient = clientReducer.clients.find((c) => c.externalUUID === searchParams.get("client"));
            if (selectedClient && !listUtils.isEmpty(selectedClient.connectedTo)) {
                const setupAuthData = selectedClient.connectedTo.find(
                    (authData) => authData.status === AuthDataStatus.SETUP
                );
                if (setupAuthData) {
                    dispatch(
                        updateConnectedAuthDataForClient({
                            ...setupAuthData,
                            endpoint: searchParams.get("merchantIdInPayPal"),
                        })
                    );
                }
            }
        }
    }, [searchParams, clientReducer.clients, dispatch]);
};

export default PaypalResponseHandler;
